/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useContext, useRef } from 'react'
import { Button, TextLink, theme } from '@provi/provi-components'
import 'react-tabs/style/react-tabs.css'
import CloseIcon from '@material-ui/icons/Close'
import { TemplateContext } from '~/components/Template/context'
import { DrawerMenuContext } from '~/components/DrawerMenu/context'
import { Title } from '~/components/title'
import { Text } from '~/themes/styles'
import { useProduct } from './hooks'
import { usePermissions } from '~/hooks'

import {
  Container,
  Content,
  SectionHeader,
  WrapperText,
  WrapperValue,
  SectionValue,
  WrapperButton,
  WrapperTextLink,
  Selector,
  CloseButton,
  WrapperClose,
  FlexWrapper,
} from './styles'

export const ProductV2 = () => {
  const { setIsLoading, setSelectedOptions, selectedOptions, setValue, value, goToPage, isMobile } = useContext(TemplateContext)
  const { drawerWidth } = useContext(DrawerMenuContext)
  const selectInputCourseClassRef = useRef()

  const { canCreateNewCrids } = usePermissions()

  const { handleOption, handleSubmit, courseOptions, list, setList, isValidSubmit, handleRemoveItem } = useProduct(
    setIsLoading,
    setSelectedOptions,
    selectedOptions,
    setValue,
    value,
    goToPage,
  )

  return (
    <>
      <Container>
        <Content isMobile={isMobile} drawerWidth={drawerWidth}>
          <SectionHeader>
            <WrapperText>
              <Title text="Selecione os itens que irão compor a venda exclusiva por CPF" />
            </WrapperText>
          </SectionHeader>
          {list &&
            list.map((item, index) => {
              return (
                <SectionValue key={index}>
                  <WrapperValue>
                    <Text tag="Course" align="start" size="16px" bold mBottom="24px" color={'#000B3C'}>
                      Selecione o curso
                    </Text>
                    <Selector
                      name="courses"
                      placeholder={isMobile ? 'Selecionar o curso' : 'Selecionar o curso desejado'}
                      options={courseOptions}
                      value={item.course || null}
                      onChange={(element) => handleOption(element, index, 'course')}
                      isOptionDisabled={(option) => list.some((key) => key && key.course && key.course.id === option.id)}
                    />
                  </WrapperValue>
                  <FlexWrapper>
                    <WrapperValue>
                      <Text tag="Course" align="start" size="16px" bold mBottom="24px" color={'#000B3C'}>
                        Selecione a turma que será vendida
                      </Text>
                      <Selector
                        ref={selectInputCourseClassRef}
                        name="course-class"
                        placeholder={isMobile ? 'Selecionar a turma' : 'Selecionar o turma desejada'}
                        isDisabled={item.courseClassOptions === undefined}
                        value={item.courseClass || null}
                        options={item.courseClassOptions && item.courseClassOptions.length ? item.courseClassOptions : []}
                        onChange={(element) => {
                          handleOption(element, index, 'courseClass')
                        }}
                      />
                    </WrapperValue>
                    {list.length > 1 && (
                      <CloseButton onClick={() => handleRemoveItem(index)}>
                        <WrapperClose>
                          <CloseIcon style={{ fontSize: 19, color: theme.colors.pink900 }} />
                        </WrapperClose>
                      </CloseButton>
                    )}
                  </FlexWrapper>
                </SectionValue>
              )
            })}

          <WrapperTextLink>
            <TextLink
              onClick={() => {
                setList((item) => {
                  return [...item, { isValid: false }]
                })
              }}
              text="Adicionar outro curso à venda"
            />
          </WrapperTextLink>
          {canCreateNewCrids && (
            <WrapperButton>
              <Button text="Avançar" onClick={handleSubmit} disabled={!isValidSubmit} />
            </WrapperButton>
          )}
        </Content>
      </Container>
    </>
  )
}
